import { defineMessages } from 'react-intl'

export default defineMessages({
  comingSoon: {
    id: 'SpacesPage.ComingSoon',
    defaultMessage: 'Coming Soon!'
  }
})
